import { RootState } from 'editor/src/store/index';

import getPreviousStates from './getPreviousStates';

const getPreviousStatesCount = (state: RootState) => getPreviousStates(state).length;

export default getPreviousStatesCount;
